import React, { useEffect, useRef, useState, useContext } from 'react'
import { HistoryRouteContext } from 'src/routes'
import { animateSlider } from 'src/lib/animationSlider'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import '../components/CardSlide.css'
import { MAIN_PATHS } from 'src/routes/main'
import NotificationIcon from 'src/components/common/NotificationIcon'

function Carousel({
  mypageImage,
  updateRecommendById,
  currentImage,
  message,
  messages,
  miniRecommendMan
}) {
  const divRef = useRef(null)
  const { redirectTo } = useContext(HistoryRouteContext)
  const [characterId, setCharacterId] = useState(currentImage)
  const [imgActive, setImgActive] = useState()
  const [imgLeft, setImgLeft] = useState()

  useEffect(() => {
    if (updateRecommendById) {
      updateRecommendById(mypageImage)
    }
  }, [currentImage])

  // function calculateCircularSteps(currentIndex, targetIndex, mypageImage) {
  //   if (currentIndex === targetIndex) {
  //     return 0 // Không cần di chuyển nếu đã ở vị trí mục tiêu
  //   }

  //   const clockwiseSteps = (targetIndex - currentIndex + mypageImage) % mypageImage
  //   const counterClockwiseSteps = (currentIndex - targetIndex + mypageImage) % mypageImage

  //   return Math.min(clockwiseSteps, counterClockwiseSteps)
  // }

  const rotateHandler = (evt) => {
    const carousel = evt.currentTarget.closest('.card-carousel')
    const rotateInt = parseInt(carousel.dataset.rotateInt || 0)
    let direction
    const newArr = mypageImage
    const currentIndex = mypageImage.findIndex((d) => d.recommend === true)
    if (evt.currentTarget.classList.contains('counterclockwise')) {
      direction = -1
      newArr[currentIndex].recommend = false
      currentIndex === newArr.length - 1
        ? (newArr[0].recommend = true)
        : (newArr[currentIndex + 1].recommend = true)
      const getId = newArr.find((item) => item.recommend === true)
      setCharacterId(getId.id)
      setImgActive(getId.imgButton)
      setImgLeft(getId.imgLeft)
    } else if (evt.currentTarget.classList.contains('clockwise')) {
      direction = 1
      newArr[currentIndex].recommend = false
      currentIndex === 0
        ? (newArr[newArr.length - 1].recommend = true)
        : (newArr[currentIndex - 1].recommend = true)
      const getId = newArr.find((item) => item.recommend === true)
      setCharacterId(getId.id)
      setImgActive(getId.imgButton)
      setImgLeft(getId.imgLeft)
    }
    carousel.dataset.rotateInt = rotateInt + direction
    animateSlider(carousel, rotateHandler)
    updateRecommendById(newArr)
  }

  useEffect(() => {
    if (mypageImage) {
      const carousels = document.querySelectorAll('.card-carousel')
      carousels?.forEach((carousel) => {
        const inner = carousel.querySelector('.inner-carousel')
        const cards = carousel.querySelectorAll('.inner-carousel > div')
        const size = cards.length
        const panelSize = inner.clientWidth
        const translateZ = Math.round(panelSize / 2 / Math.tan(Math.PI / size)) * 1.7
        inner.style.transform = `rotateY(0deg) translateZ(-${translateZ}px)`
        animateSlider(carousel, rotateHandler)
      })
    }
  }, [mypageImage])

  function calculateSteps(currentIndex, targetIndex, arrayLength) {
    if (currentIndex === targetIndex) {
      return { step: 0, isNext: false }
    }

    const prev = (currentIndex - targetIndex + arrayLength) % arrayLength
    const next = (targetIndex - currentIndex + arrayLength) % arrayLength

    return next > prev ? { step: prev, isNext: false } : { step: next, isNext: true }
  }

  const rotateNext = (id) => {
    setCharacterId(id)
    const newArr = mypageImage
    const currentIndex = mypageImage.findIndex((d) => d.recommend === true)
    const targetIndex = mypageImage.findIndex((d) => d.id === id)
    newArr[currentIndex].recommend = false
    newArr[targetIndex].recommend = true
    setImgActive(newArr[targetIndex].imgButton)
    setImgLeft(newArr[targetIndex].imgLeft)
    const carousel = document.querySelector('.card-carousel')
    let rotateInt = parseInt(carousel.dataset.rotateInt || 0)
    const value = calculateSteps(currentIndex, targetIndex, newArr.length)
    if (value.isNext) {
      rotateInt -= value.step
    } else {
      rotateInt += value.step
    }
    carousel.dataset.rotateInt = rotateInt
    animateSlider(carousel, rotateHandler)
    updateRecommendById(newArr)
  }

  useEffect(() => {
    const checkIconNew = mypageImage.find((item) => item.id === characterId)
    const conversation = messages.find((x) => x.conversation_id === message?.conversation_id)
    if (conversation?.character?.id === characterId) {
      checkIconNew.unreadTotal = 1
    }
  }, [characterId, message])

  return (
    <>
      {mypageImage.length > 0 && (
        <ResponSiveDisplayScreen className="card-carousel" ref={divRef}>
          <ResponSiveDisplaySlide className="inner-carousel h-full !top-0">
            {mypageImage?.map((item, index) => (
              <ResponSiveDisplay
                characterId={item.id}
                key={index}
                style={{ filter: !item.recommend ? '' : '' }}
                className={`ml-2 flex justify-center ${
                  item.recommend ? 'first-slide' : ''
                }`}
              >
                <img
                  className="img-slide h-full object-cover mx-auto"
                  src={item.recommend === true ? item.imageActive : item.imageGray}
                />
              </ResponSiveDisplay>
            ))}
          </ResponSiveDisplaySlide>
          <ResponSiveDisplayButton className="flex justify-between items-center w-4/5 bottom-[55%] absolute px-16">
            <button onClick={rotateHandler} className=" z-[100] clockwise ">
              <img className="w-[6dvw] sm:w-7" src={imgLeft || mypageImage[0].imgLeft} />
            </button>
            <button onClick={rotateHandler} className=" z-[100] counterclockwise  ">
              <img className="w-[6dvw] sm:w-7 rotate-180" src={imgLeft || mypageImage[0].imgLeft} />
            </button>
          </ResponSiveDisplayButton>
          <ReponsiveDisplayName className="w-full flex justify-center absolute bottom-[12dvh]">
            <button
              className="z-[9] w-[220px]"
              onClick={() =>
                redirectTo(MAIN_PATHS.RealTalkDetailPage.replace(':characterId', characterId))
              }
            >
              <ReponsiveNameButton src={imgActive || mypageImage[0].imgButton} />
            </button>
          </ReponsiveDisplayName>
          <ResponSiveDisplayIcon className="absolute bottom-0 right-0 w-[58px] flex flex-col gap-1 justify-around items-center py-4 rounded-tl-3xl h-72">
            <div className='h-full overflow-y-scroll hidden-scroll'>
              {miniRecommendMan.map((item, index) => (
                <div key={index} className="relative" onClick={() => rotateNext(item.id)}>
                  <ResponSiveDisplayIconImg src={item.imgIcon} className="w-[44px]" />
                  {item.unreadTotal > 0 && <NotificationIcon />}
                </div>
              ))}
            </div>
          </ResponSiveDisplayIcon>
        </ResponSiveDisplayScreen>
      )}
    </>
  )
}

const ResponSiveDisplay = styled.div`
  @media (max-width: 480px) {
    height: 60dvh;
    top: -7dvh !important;
  }
  @media (max-width: 420px) {
    height: 53dvh;
    top: -7dvh !important;
  }

  @media (max-width: 380px) {
    top: -9dvh !important;
    height: 55dvh;
  }
  @media (max-width: 350px) {
    height: 40dvh;
  }
  top: 4dvh !important;
  height: 46dvh;
`

const ResponSiveDisplayIcon = styled.div`
  background-image: linear-gradient(to right, #c0e4ff, #d3b8ff);
  background-size: cover;
  background-blend-mode: overlay;
`

const ReponsiveNameButton = styled.img`
  display: block;
  margin-left: auto;
  margin-right: auto;
  @media (max-width: 375px) {
    height: 60px;
    width: auto;
  }
`

const ResponSiveDisplayIconImg = styled.img``

const ResponSiveDisplaySlide = styled.div`
  @media (max-width: 380px) {
    top: -30px !important;
  }
`
const ResponSiveDisplayButton = styled.div`
  right: 40px;
  @media (max-width: 480px) {
    top: 50%;
    right: 10%;
  }
`

const ResponSiveDisplayScreen = styled.div`
  @media (max-width: 375px) {
  }
`
const ReponsiveDisplayName = styled.div`
  @media (min-width: 480px) {
    bottom: 2dvh;
    height: 46dvh;
    width: 100%;
  }
  @media (max-width: 480px) {
    right: 0%;
  }
  @media (max-width: 350px) {
    bottom: 2dvh;
    height: 46dvh;
    width: 100%;
  }
`

Carousel.propTypes = {
  mypageImage: PropTypes.array,
  currentImage: PropTypes.number,
  updateRecommendById: PropTypes.func,
  setCurrentImage: PropTypes.func,
  messages: PropTypes.array,
  setRecommendMan: PropTypes.func,
  miniRecommendMan: PropTypes.array,
  message: PropTypes.any
}

export default Carousel
